import * as React from "react";
import { Checkbox as ShadcnCheckbox } from "src/shadcn/components/checkbox";
import { cn } from "src/shadcn/lib/utils";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof ShadcnCheckbox>,
  React.ComponentProps<typeof ShadcnCheckbox>
>(({ className, ...props }, ref) => (
  <ShadcnCheckbox
    ref={ref}
    className={cn(
      "cursor-pointer border-neutral-400 dark:border-neutral-500",
      className
    )}
    {...props}
  />
));

Checkbox.displayName = "Checkbox";

export { Checkbox };
